export default function convertSVGtoIMG(SVG_STRING) {
    var svg64 = window.btoa(SVG_STRING);
    var b64Start = 'data:image/svg+xml;base64,';
    var image64 = b64Start + svg64;
    return image64;
}